import React from 'react';
import './AnimatedBackground.scss';

const AnimatedBackground = ({className = '', variant = 'default', showGrid = true, showFloatingElements = true, showWaves = true, showStars = true}) => {
	// Generate random positions for stars
	const generateStarPositions = () => {
		return Array.from({length: 10}, (_, i) => ({
			id: i,
			top: Math.random() * 90 + 5, // 5% to 95%
			left: Math.random() * 90 + 5, // 5% to 95%
			type: (i % 4) + 1,
			delay: Math.random() * 8,
		}));
	};

	const starPositions = generateStarPositions();

	return (
		<div className={`animated-background  bg-gradient-to-br from-deepBlue via-navy to-darkBlue ${variant} ${className}`}>
			{/* 3D Floating Waves Background */}
			{showWaves && (
				<div className="animated-background__waves">
					{/* Multiple 3D Wave Layers */}
					<div className="animated-background__waves-container">
						<svg className="animated-background__waves-svg" viewBox="0 0 1200 800" preserveAspectRatio="none">
							<defs>
								<linearGradient id="wave3d1" x1="0%" y1="0%" x2="100%" y2="100%">
									<stop offset="0%" stopColor="#ffffff" stopOpacity="0.1" />
									<stop offset="50%" stopColor="#2f54eb" stopOpacity="0.15" />
									<stop offset="100%" stopColor="#ffffff" stopOpacity="0.05" />
								</linearGradient>
								<linearGradient id="wave3d2" x1="0%" y1="0%" x2="100%" y2="100%">
									<stop offset="0%" stopColor="#2f54eb" stopOpacity="0.12" />
									<stop offset="100%" stopColor="#ffffff" stopOpacity="0.08" />
								</linearGradient>
								<linearGradient id="wave3d3" x1="0%" y1="0%" x2="100%" y2="100%">
									<stop offset="0%" stopColor="#ffffff" stopOpacity="0.08" />
									<stop offset="100%" stopColor="#2f54eb" stopOpacity="0.04" />
								</linearGradient>
							</defs>

							{/* First 3D wave layer */}
							<path fill="url(#wave3d1)" className="animated-background__wave animated-background__wave--1" filter="blur(1px)">
								<animate
									attributeName="d"
									values="M0,200 C300,100 600,300 900,200 C1050,150 1200,250 1200,250 L1200,800 L0,800 Z;
                          M0,250 C300,350 600,50 900,150 C1050,100 1200,200 1200,200 L1200,800 L0,800 Z;
                          M0,200 C300,100 600,300 900,200 C1050,150 1200,250 1200,250 L1200,800 L0,800 Z"
									dur="12s"
									repeatCount="indefinite"
								/>
							</path>

							{/* Second 3D wave layer */}
							<path fill="url(#wave3d2)" className="animated-background__wave animated-background__wave--2" filter="blur(2px)">
								<animate
									attributeName="d"
									values="M0,300 C400,200 800,400 1200,300 L1200,800 L0,800 Z;
                          M0,350 C400,450 800,150 1200,250 L1200,800 L0,800 Z;
                          M0,300 C400,200 800,400 1200,300 L1200,800 L0,800 Z"
									dur="16s"
									repeatCount="indefinite"
								/>
							</path>

							{/* Third 3D wave layer */}
							<path fill="url(#wave3d3)" className="animated-background__wave animated-background__wave--3" filter="blur(3px)">
								<animate
									attributeName="d"
									values="M0,400 C500,300 700,500 1200,400 L1200,800 L0,800 Z;
                          M0,450 C500,550 700,250 1200,350 L1200,800 L0,800 Z;
                          M0,400 C500,300 700,500 1200,400 L1200,800 L0,800 Z"
									dur="20s"
									repeatCount="indefinite"
								/>
							</path>
						</svg>
					</div>
				</div>
			)}

			{/* Starry Elements */}
			{showStars && (
				<div className="animated-background__stars">
					{starPositions.map((star) => (
						<div
							key={star.id}
							className={`animated-background__star animated-background__star--${star.type}`}
							style={{
								top: `${star.top}%`,
								left: `${star.left}%`,
								animationDelay: `${star.delay}s`,
							}}></div>
					))}
				</div>
			)}

			{/* 3D Floating Elements */}
			{showFloatingElements && (
				<div className="animated-background__floating-elements">
					<div className="animated-background__floating-element animated-background__floating-element--1"></div>
					<div className="animated-background__floating-element animated-background__floating-element--2"></div>
					<div className="animated-background__floating-element animated-background__floating-element--3"></div>
				</div>
			)}

			{/* Subtle 3D Grid */}
			{showGrid && <div className="animated-background__grid"></div>}
		</div>
	);
};

export default AnimatedBackground;
